<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader title="MD 2 - Investment Experience and Knowledge" :icon="UsersIcon"></WizardHeader>
            <ManagerListItem class="border-y border-gray-200 px-2 py-2" :manager="currentManager"></ManagerListItem>
            <div class="px-4 pb-6 sm:px-6">
                <LegalPersonExperienceAndKnowledgeForm
                    v-model="experienceAndKnowledge"></LegalPersonExperienceAndKnowledgeForm>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary
                :loading="usePersonalAccountDataState().saving"
                :disabled="usePersonalAccountDataState().saving || formState.hasValidationErrors"
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                {{ $t('esac_widget_sidebar.legal_manager_two_experience_and_knowledge') }}
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<script setup lang="ts">
import WizardTabWithSidebar from '../../WizardTabWithSidebar.vue'
import WizardHeader from '../../WizardHeader.vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import {
    EsacComplianceProfile,
    ExperienceAndKnowledge,
    usePersonalAccountDataState,
} from '../../../../utilities/account/useAccountDataPersonal'
import { useLegalAccountFormState } from '../../../../utilities/account/useAccountFormLegal'
import { computed, inject, onMounted, ref } from 'vue'
import { UsersIcon } from '@heroicons/vue/outline'
import ManagerListItem from '../../../account/legal/managers/ManagerListItem.vue'
import LegalPersonExperienceAndKnowledgeForm from './form/LegalPersonExperienceAndKnowledgeForm.vue'
import { putManager } from '../../../../utilities/api'
import { currentNewManager } from './manager'

const formState = useLegalAccountFormState()
const { navigateToNextTab, navigateToPreviousTab } = inject('navigation')

const experienceAndKnowledge = ref(new ExperienceAndKnowledge())

const currentManager = computed(() => {
    return currentNewManager.value
})

onMounted(() => {
    if (currentManager.value.compliance_profiles?.esac?.experience_and_knowledge) {
        experienceAndKnowledge.value = currentManager.value.compliance_profiles.esac.experience_and_knowledge
    } else {
        experienceAndKnowledge.value = new ExperienceAndKnowledge()
    }
})

async function submit() {
    const { valid } = await formState.currentForm.validate()
    if (valid) {
        let payload = currentManager.value
        if (Array.isArray(payload.compliance_profiles)) {
            payload.compliance_profiles = {}
        }
        payload.compliance_profiles.esac = Object.assign(new EsacComplianceProfile(), payload.compliance_profiles.esac)
        payload.compliance_profiles.esac.experience_and_knowledge = experienceAndKnowledge.value
        await putManager(currentManager.value.natural_profile_uid, payload)
        navigateToNextTab()
    }
}
</script>

<style scoped></style>
